import { LoadingStatusValues } from '@/utils/constants';
import { createContext } from 'react';

export const DefaultElasticPagination = {
  currentPage: 1,
  resultsPerPage: 0,
  totalResults: 0,
  totalPages: 1,
  from: 0,
  to: 0,
};

export interface FacetsType {
  name: string;
  label: string;
  options: Array<{
    value: string;
    count: string | number;
    selected?: boolean;
  }>;
}

export interface ElasticComponentContextType {
  queryParams: Record<string, string | number | string[] | any>;
  updateQueryParams: (key: string, value: any, multiple?: boolean) => void;
  forceUpdate?: () => void;
  externalIDUpdate?: () => void;
  resetParams?: () => void;
  hideFilters?: string[];
  facets: FacetsType[];
  sortOptions: any[];
  labels?: any;
  engine?: string;
  authEngine?: string;
  callbackExternalFilters?: () => void;
  // sortType: 'asc' | 'desc';
  status: LoadingStatusValues.initial | LoadingStatusValues.loading | LoadingStatusValues.ready;
  results: any[];
  pagination: {
    currentPage: number;
    resultsPerPage: number;
    totalResults: number;
    totalPages: number;
    from: number;
    to: number;
  };
  manualUpdate?: boolean;
  requestID?: string;
  searchKey?: string;
}

const ElasticComponentContext = createContext<ElasticComponentContextType>({
  queryParams: {},
  updateQueryParams: () => null,
  engine: '',
  forceUpdate: () => null,
  externalIDUpdate: () => null,
  callbackExternalFilters: () => null,
  resetParams: () => null,
  hideFilters: [],
  facets: [],
  sortOptions: [],
  labels: {},
  // sortType: 'asc',
  status: LoadingStatusValues.ready,
  results: [],
  pagination: DefaultElasticPagination,
  manualUpdate: false,
  requestID: '',
});

export default ElasticComponentContext;
